import { useInsightTableItems } from 'modules/finance/components/FinancialWorkspace/hooks/useInsightTableItems'
import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'
import { TableDataVariables } from 'modules/finance/components/FinancialWorkspace/types/table'

const formatVariables = (variables: TableDataVariables) => {
  // remove pagination options and unused common variables
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { offset, itemsPerPage, formattedCompareToEndDate, formattedCompareToStartDate, ...rest } =
    variables

  return {
    resourceFilter: {
      ...rest,
      forEmployeeCosts: true, // All total and charts should use for_employee_costs
      groupBy: InsightTableGroupBy.Total,
    },
  }
}

export const useEvolutionChartData = (variables: TableDataVariables, skip?: boolean) => {
  const { resourceFilter } = formatVariables(variables)

  const result = useInsightTableItems(
    {
      resourceFilter,
    },
    skip
  )

  return result
}
